/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Subtitle_File_TitleInputs */



/**
* | output |
* | --- |
* | "Subtitle File" |
*
* @param {File_Export_Subtitle_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_subtitle_file_title = /** @type {((inputs?: File_Export_Subtitle_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Subtitle_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de legenda")
	return /** @type {LocalizedString} */ ("Subtitle File")
});